module.exports = __webpack_public_path__ + "static/media/timing-dark.2544f006.svg";